import React from 'react';
import { useTheme } from '@emotion/react';
import { Icon } from '@pairy/pds-react';

type Props = {
  children: React.ReactNode;
  onUpgradeClick?: () => void;
  showBorder?: boolean;
  borderRadius?: number;
};

const BlurredCompactItem = ({
  children,
  onUpgradeClick,
  showBorder = false,
  borderRadius = 8,
}: Props) => {
  const theme = useTheme();

  return (
    <div
      style={{
        position: 'relative',
        ...(showBorder && {
          border: `1px solid ${theme.colors.zinc_200}`,
          borderRadius,
          overflow: 'hidden',
        }),
      }}
    >
      <div
        style={{
          filter: 'blur(6px)',
          opacity: 0.6,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
        aria-hidden
      >
        {children}
      </div>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
        onClick={onUpgradeClick}
      >
        <Icon icon="ph:lock-fill" size={20} color="zinc_400" />
      </div>
    </div>
  );
};

export default BlurredCompactItem;
